import React from 'react';
import { DatePicker, Space } from 'antd';
import styled from 'styled-components';

const StyledDatePicker = styled(DatePicker)`
  width: ${props => props.width || '352px'};
  height: ${props => props.height || '40px'};
  font-size: ${props => props.dark ? '12px' : '16px'};
  border-radius: ${props => props.dark ? '8px' : '4px'};
  transition: border-color 0.3s ease;

  &:hover {
    border-color: ${props => props.dark ? '#64748b' : '#ee0434'};
  }

  &.ant-picker-focused {
    border-color: ${props => props.dark ? '#3b82f6' : '#ee0434'};
    box-shadow: ${props => props.dark ? '0 0 0 2px rgba(59, 130, 246, 0.2)' : ''};
  }

  .ant-picker-input > input {
    height: 100%;
    line-height: ${props => props.height || '40px'};
  }

  ${props => props.dark && `
    background-color: #1e293b;
    border-color: #334155;
    .ant-picker-input > input {
      color: #e2e8f0;
    }
    .ant-picker-clear {
      background: #1e293b;
      color: #64748b;
    }
    .ant-picker-suffix {
      color: #64748b;
    }
    .ant-picker-input > input::placeholder {
      color: #64748b;
    }
  `}
`;

const DateTimeAntd = ({showTime, format, dateTime, onChange, onOk, width, height, dark }) => {
  return (
    <Space direction="vertical" size={12} style={{ width: width || '352px' }}>
      <StyledDatePicker
        showTime={showTime}
        format={format}
        value={dateTime}
        onChange={onChange}
        onOk={onOk}
        placeholder="Chọn thời gian"
        width={width}
        height={height}
        dark={dark ? 1 : 0}
        popupStyle={{ zIndex: 9999 }}
      />
    </Space>
  );
};

export default React.memo(DateTimeAntd);
